import { Pipe, PipeTransform } from '@angular/core';

import { Product } from '@services/products/interfaces/product.interfaces';
import { Utils } from '@shared/utils/utils';

/**
 * Catalog `basePrice` is the cheapest option: keychains depend on the configuration, so they
 * are shown as "from". Merchandising is always quoted by email, so it shows no price.
 */
@Pipe({
  name: 'catalogPrice',
  standalone: true,
})
export class CatalogPricePipe implements PipeTransform {
  private readonly utils = new Utils();

  transform(product: Pick<Product, 'basePrice' | 'productType' | 'isKeychain'>): string {
    if (product.productType === 'merchandising') {
      return '';
    }

    const price = this.utils.formatCurrency(product.basePrice);

    if (product.isKeychain || product.productType === 'keychain') {
      return `Desde ${price}`;
    }

    return price;
  }
}
